export const enum remoteConfigKeys {
  SHOW_BANNER_AD = "show_banner_ad",
  BANNER_AD_UNIT_ID_ANDROID = "banner_ad_unit_id_android",
  BANNER_AD_UNIT_ID_IOS = "banner_ad_unit_id_ios",
}

export const defaultRemoteConfig = {
  [remoteConfigKeys.SHOW_BANNER_AD]: false,
  [remoteConfigKeys.BANNER_AD_UNIT_ID_ANDROID]:
    "ca-app-pub-7056696874970870/2313899301",
  [remoteConfigKeys.BANNER_AD_UNIT_ID_IOS]:
    "ca-app-pub-7056696874970870/8797624590",
};
